module.exports = __webpack_public_path__ + "static/show_times_multiday_items_in_all_day_area_example-e4ce30b3926e1303ec3c69fc78c18e90.png";